import { CodeDepot, CodesDepotPlateforme } from 'constants.js';

/**
 * Retourne la pièce gestion sélectionnée sur la réclamation, depuis le store namespacé.
 * Même résolution que celle dupliquée dans les containers de steps de qualification.
 */
export const getPieceSelectionnee = (state, namespace, reclamation) => {
    if (!namespace || !reclamation || !state.pieceGestion[namespace]) {
        return null;
    }

    const piecesGestion = state.pieceGestion[namespace].piecesGestion;

    return piecesGestion
        ? piecesGestion.items.find(p => p.numeroPiece === reclamation.numeroPiece) ?? null
        : null;
};

/** Vrai si la pièce provient du dépôt Rapido (15). */
export const estPieceRapido = piece => !!piece && piece.codeDepot === CodeDepot.Rapido;

/** Vrai si le code correspond à une plateforme logistique (Monné 01 / Vaulx 70). */
export const estDepotPlateforme = code => CodesDepotPlateforme.indexOf(code) !== -1;

/**
 * Vrai si l'utilisateur n'a pas de dépôt magasin exploitable : soit aucun dépôt rattaché,
 * soit un dépôt plateforme (Monné / Vaulx). Dans ce cas le magasin doit être choisi
 * parmi utilisateur.depots plutôt que déduit de utilisateur.depot.
 */
export const sansDepotMagasin = utilisateur =>
    !utilisateur || !utilisateur.depot || estDepotPlateforme(utilisateur.depot.code);
